import React, {useState} from "react";
import useIsMounted from "../../../../hooks/use-is-mounted";
import Api from "../../../../../core/services/api/api";
import {Col} from "reactstrap";
import * as $ from "jquery";
import {SvgIcon, Tooltip} from "@mui/material";
import classnames from "classnames";
import IconButton from "../../../base/button/icon_button";
import {ReactComponent as BookmarkFilledIcon} from "../../../../../assets/images/notifications/bookmark-filled.svg";
import {ReactComponent as BookmarkIcon} from "../../../../../assets/images/notifications/bookmark.svg";
import DateUtils from "../../../../../core/services/date-utils";
import Utils from "../../../../../core/services/utils/utils";
import useAccessLevels from "../../../../hooks/use-access-levels";


const NotificationCard = ({notification, syncNotification, unAuthorizedOrAccessDeniedCallback}) => {
    const [togglingReadStatus, setTogglingReadStatus] = useState(false)
    const [togglingSavedStatus, setTogglingSavedStatus] = useState(false)
    const isMounted = useIsMounted();
    const {packages} = useAccessLevels();
    const canViewList = packages.notifications.viewList;

    /**
     * navigates to the notification's targeted page.
     */
    const onNotificationClicked = () => {
        //TODO: navigate to the notification's targeted page.
    }

    /**
     * toggles the notification read status in the server.
     */
    const toggleNotificationReadStatus = () => {
        if (!canViewList) return;
        if (togglingReadStatus)
            return;
        setTogglingReadStatus(true);
        Api.toggleNotificationRaedStatus(notification.id, unAuthorizedOrAccessDeniedCallback).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                syncNotification(response.data, true)
            }
            setTogglingReadStatus(false)
        })
    }

    /**
     * Toggles notification's saved status.
     */
    const toggleNotificationSavedStatus = () => {
        if (!canViewList) return;
        setTogglingSavedStatus(true);
        Api.toggleNotificationSavedStatus(notification.id, unAuthorizedOrAccessDeniedCallback).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                syncNotification(response.data)
            }
            setTogglingSavedStatus(false)
        })
    }


    return (
        <>
            <div className='mb-2 notification-card' onClick={onNotificationClicked}>
                <Col xs={9} className={'d-flex p-0'}>
                    {
                        notification?.senderApplication &&
                        <img className={'img sharp'}
                             src={Utils.encodeFileUrl(notification?.senderApplication?.logoUrl)}
                             alt={notification?.senderApplication?.name}
                        />
                    }
                    <div
                        className={'d-flex flex-column flex-grow-1 ml-2'}>
                        <p className='title'>
                            {notification.title ?? ''}
                            <span>
                                {
                                    notification.submitDateTime
                                        ? DateUtils.serverToLocal(notification.submitDateTime).fromNow()
                                        : ''
                                }
                            </span>
                        </p>
                        <div className='d-flex w-100 justify-content-start align-items-center no-padding'>
                            <p className='body'>
                                {notification.body ?? ''}
                            </p>
                        </div>
                    </div>
                </Col>
                <Col xs={'auto'} className={'h-100 pr-1'} style={{
                    minHeight: $('.notification-card').height(),
                }}>
                    <Tooltip
                        placement={'left'}
                        title={notification.isRead ? "mark as un-read" : 'mark as read'}
                        disableInteractive>
                        <div>
                            <div
                                className={'status-container'}
                                onClick={toggleNotificationReadStatus}
                            >
                                <div className={'status-parent'}>
                                    <div className={classnames('status', {'read': notification.isRead})}/>
                                </div>
                            </div>
                        </div>

                    </Tooltip>
                    <div className={''}>
                        <IconButton
                            disabled={togglingReadStatus || togglingSavedStatus}
                            onPressed={toggleNotificationSavedStatus}
                            color={'paper.secondary'}
                        >
                            <SvgIcon
                                className={'icon normal'}
                                component={
                                    (!!notification.userCategory || notification.isSaved)
                                        ? BookmarkFilledIcon
                                        : BookmarkIcon
                                }
                                {
                                    ...(!!notification.userCategory
                                            ? {
                                                htmlColor: notification.userCategory.colorCode
                                            }
                                            : notification.isSaved
                                                ? {
                                                    htmlColor: '#4F4F4F',
                                                }
                                                : {}
                                    )
                                }
                            />
                        </IconButton>
                    </div>
                </Col>
            </div>
            <div className={'divider'}/>
        </>
    );
}
export default NotificationCard;
